import { EntityModel } from '@cksoftware/react-base';
import { useGenericCrudInfiniteListQuery } from '../../../../hooks/useGenericCrudInfiniteListQuery.ts';
import { InfiniteList } from './InfiniteList.tsx';
import { Box } from '@chakra-ui/react';
import { ApiRoute } from '../../../../../../constants/apiRoutes/apiRoute.ts';
import { PaginationQueryParams } from '../../../../../../constants/apiRoutes/paginationQueryParams.ts';
import { ReactElement } from 'react';

interface GenericInfiniteListProps<T> {
  emptyListMessage?: string;
  route: ApiRoute<PaginationQueryParams>;
  queryParameters: PaginationQueryParams;
  renderItem: (item: T) => ReactElement;
  height?: number | string;
}

export const GenericInfiniteList = <T extends EntityModel>(props: GenericInfiniteListProps<T>) => {
  const { route, queryParameters, renderItem, height, emptyListMessage } = props;
  const { data, fetchNextPage, hasNextPage, isLoading } = useGenericCrudInfiniteListQuery<T>(route, queryParameters);

  return (
    <Box overflow='hidden'>
      <InfiniteList
        height={height}
        emptyListMessage={emptyListMessage}
        items={data?.pages.flatMap((page) => page.PagedRows) || []}
        fetchNextPage={fetchNextPage}
        hasNextPage={hasNextPage}
        isLoading={isLoading}
        renderItem={renderItem}
      />
    </Box>
  );
};
